export const SKIP_LOGIN_SERVER = process.env.skipAuth === 'true';
